import { LWWRegister, mergeLWWRegister } from "./lwwRegister.js";

export type ORMapEntry = Record<string, LWWRegister<unknown>>;
export type ORMap = Record<string, ORMapEntry>;

export function mergeORMap(local: ORMap | undefined, remote: ORMap | undefined): ORMap {
  const merged: ORMap = { ...(local ?? {}) };
  const keys = new Set([...Object.keys(local ?? {}), ...Object.keys(remote ?? {})]);

  for (const key of keys) {
    const localEntry = local?.[key];
    const remoteEntry = remote?.[key];
    if (!localEntry && remoteEntry) {
      merged[key] = { ...remoteEntry };
      continue;
    }
    if (localEntry && !remoteEntry) {
      merged[key] = { ...localEntry };
      continue;
    }
    if (!localEntry || !remoteEntry) continue;

    const entry: ORMapEntry = { ...localEntry };
    const fieldKeys = new Set([
      ...Object.keys(localEntry),
      ...Object.keys(remoteEntry),
    ]);
    for (const field of fieldKeys) {
      entry[field] = mergeLWWRegister(localEntry[field], remoteEntry[field])!;
    }
    merged[key] = entry;
  }

  return merged;
}

export function isDeviceRevoked(entry: ORMapEntry | undefined): boolean {
  const revoked = entry?.revoked_at;
  return revoked != null && revoked.value != null;
}
